export const cutString = (string, separator) => {
  const copyString = string
  return copyString.split(separator)
}